import { Pipe, PipeTransform } from '@angular/core';
import {makeDataTestingIdForString} from "@webmate-web-core/shared/utils/utils";


@Pipe({standalone: true, name: 'dataTestingId'})
export class DataTestingIdPipe implements PipeTransform {
    transform(value: string): string {
        return makeDataTestingIdForString(value);
    }
}
